export default "/_next/static/assets/images/sprite.f0a6c560df310007856d5aa18a81e029.svg";